import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import front from "../assets/front.png";
import design from "../assets/design.png";
import soft from "../assets/soft.png";
import { skills } from "../data";
import styles from "./skills.module.css";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "300px",
    height: "400px",
    background: "rgba(0,0,0,0.5)",
    color: "rgba(255,255,255,.7)",
  },
  divImg: {
    width: "200px",
    height: "200px",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
  },
  img: {
    width: "100%",
  },
  subtitle:{
    fontSize: "1.7em"
  }
}));

export default function Skills() {
  const classes = useStyles();

  function rate(data) {
    return {
      background: `linear-gradient(to right,purple ${data}%, white ${
        100 - data
      }%)`,
    };
  }

  return (
    <section id="skills" className={styles.container}>
      <div className={styles.card}>
        <div className={styles["card-image"]}>
          <img alt="" src={front} className={classes.img} />
        </div>
        <div className={styles.paper}>
          <div className={styles.title}>
            <Typography align="center" className={classes.subtitle}>
              FRONTEND
            </Typography>
          </div>
          <div className={styles["card-content"]} style={{ overflowY: "auto", height: "90%" }}>
            {skills.front.map((skill) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  paddingTop: "10px",
                }}
              >
                <img src={skill.icon} alt="" className={styles.icon} />
                <div style={{ color: "white" }}>
                  <Typography>{skill.name}</Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                    }}
                  >
                    <div className={styles.bar} style={rate(skill.rate)} />
                    {/* <span>{skill.rate}%</span> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div item xs className={styles.card} direction="column">
        <div className={styles["card-image"]}>
          <img alt="" src={design} className={classes.img} />
        </div>
        <div className={styles.paper}>
          <div className={styles.title}>
            <Typography align="center" className={classes.subtitle}>
              BACKEND
            </Typography>
          </div>
          <div className={styles["card-content"]} style={{ overflowY: "auto", height: "90%" }}>
            {skills.back.map((skill) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  paddingTop: "10px",
                }}
              >
                <img src={skill.icon} alt="" className={styles.icon} />
                <div style={{ color: "white" }}>
                  <Typography>{skill.name}</Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                    }}
                  >
                    <div className={styles.bar} style={rate(skill.rate)} />
                    {/* <span>{skill.rate}%</span> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div item xs className={styles.card} direction="column">
        <div className={styles["card-image"]}>
          <img alt="" src={soft} style={{ width: "90%" }} />
        </div>
        <div className={styles.paper}>
          <div className={styles.title}>
            <Typography align="center" className={classes.subtitle}>
              SERVICES
            </Typography>
          </div>
          <ul className={[`${styles['card-content']} ${styles.services}`]} style={{ fontSize: "1.4em", paddingLeft: "30px" , overflowY: "auto"}}>
            <li>JSON Web Token</li>
            <li>PassportJS</li>
            <li>Google Auth</li>
            <li>Facebook Auth</li>
            <li>Mailgun</li>
            <li>Nodemailer</li>
            <li>Expo</li>
            <li>Socket.io</li>
            <li>MercadoPago Checkout</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
